import React, { useEffect, Fragment } from "react";
import { Form, Button, Input, Select, Switch } from "antd";
import { fetchCategories } from "../../actions/category";
import { useDispatch, useSelector } from "react-redux";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

import "./Question.scss";
import { PAGE_SIZE } from "../../constants";
import { ReactSVG } from "react-svg";

const QuestionForm = ({ handleSubmitForm, form, handleCancel, questionId }) => {
	const dispatch = useDispatch();
	const { categories } = useSelector((state) => state.fetchCategories);
	const { question } = useSelector((state) => state.fetchQuestion);

	useEffect(() => {
		if (!categories) dispatch(fetchCategories({ start: 0, count: PAGE_SIZE }));
	}, [categories]);

	useEffect(() => {
		if (question) form.setFieldsValue(question);
	}, [question]);

	return (
		<div className="question-form-container">
			<Form form={form} onFinish={handleSubmitForm} requiredMark={false}>
				<div className="form-content-group">
					<Form.Item
						label="Name"
						name="name"
						rules={[{ required: true, message: "Required" }]}
					>
						<Input placeholder="Name" />
					</Form.Item>
					<Form.Item label="Type" name="type" hidden={true}>
						<Select placeholder="Type">
							<Select.Option value="point">Point</Select.Option>
							<Select.Option value="result">Result</Select.Option>
						</Select>
					</Form.Item>
					<Form.Item label="Question Kind" name="question_kind" hidden={true}>
						<Select placeholder="Question Kind">
							<Select.Option value="radio">Radio</Select.Option>
							<Select.Option value="multiple_choice">
								Multiple Choice
							</Select.Option>
						</Select>
					</Form.Item>
					<Form.Item
						label="Survey Category"
						name="survey_category_id"
						hidden={true}
					>
						{categories && (
							<Select
								showSearch
								maxTagCount={"responsive"}
								placeholder="Survey Category"
								optionFilterProp="children"
								filterOption={(input, option) =>
									option.children.toLowerCase().indexOf(input.toLowerCase()) >=
									0
								}
							>
								{categories.data.data.map((category, index) => (
									<Select.Option key={index} value={category.id}>
										{category.name}
									</Select.Option>
								))}
							</Select>
						)}
					</Form.Item>
					<div className="answers-list-form">
						<Form.List name="answers" hidden={true}>
							{(fields, { add, remove }, { errors }) => (
								<Fragment>
									{fields.map(({ key, name, fieldKey, ...restField }) => (
										<Form.Item
											key={key}
											label={`Answer ${name + 1}`}
											hidden={true}
										>
											<Form.Item
												{...restField}
												name={[name, "name"]}
												fieldKey={[fieldKey, "name"]}
												rules={[
													{ required: true, message: "Missing Answer name" },
												]}
											>
												<Input placeholder="Answer" style={{ width: "100%" }} />
											</Form.Item>
											{fields.length > 1 ? (
												<MinusCircleOutlined
													className="dynamic-delete-button"
													onClick={() => remove(name)}
												/>
											) : null}
										</Form.Item>
									))}
									<Form.Item hidden={true}>
										<Button
											type="dashed"
											onClick={() => add()}
											style={{ width: "100%" }}
											icon={<PlusOutlined />}
										>
											Add Answer
										</Button>
										<Form.ErrorList errors={errors} />
									</Form.Item>
								</Fragment>
							)}
						</Form.List>
					</div>
					<Form.Item
						label="Require"
						name="require"
						valuePropName="checked"
						hidden={true}
					>
						<Switch />
					</Form.Item>
				</div>
				<div className="form-actions">
					<Button type="link" onClick={handleCancel}>
						{" "}
						Cancel{" "}
					</Button>
					<Button type="primary" htmlType="submit" className="btn-primary">
						{questionId ? "Update" : "Create"}
						<ReactSVG src="/icons/check-button.svg" />
					</Button>
				</div>
			</Form>
		</div>
	);
};

export default QuestionForm;
